import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/(main)/callouts')({
    beforeLoad: ({ search }) => {
        throw redirect({
            to: '/outreaches',
            search,
        });
    },
});
